import { CSSObject } from '@emotion/react';

export const buttonIncreaseProps: CSSObject = {
  h: '26px',
  lineHeight: 1,
};
